import * as _ from 'lodash';
import * as utility from '../misc/utility';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

export class BaseObject {
    /**
     * @param {ResponseContext} _ctx
     * @param {any} _src
     */
    resolve(_ctx, _src) {
    }

    toJSON() {
        var ret = {};

        for (let key of _.keysIn(this)) {
            if (typeof key === 'string' && key.length > 0) {
                var firstChar = key.charAt(0);
                if (firstChar.toLowerCase() !== firstChar) {
                    ret[key] = this[key];
                }
            }
        }

        return ret;
    }

    static withRelated(obj, name) {
        var ret = obj[name];
        if (ret == null)
            return undefined;
        delete obj[name];
        if (_.isArray(ret))
            return ret.map(function (x) { return x && x.Id; }).filter(utility.isGuid);
        if (utility.isGuid(ret.Id))
            return ret.Id;
        return undefined;
    }
}
